export default "__VITE_ASSET__BXsKYBT6__"